export default __webpack_public_path__ + "images/logoErasa.b6922fe00918d5fddc8883fbd18a0050.svg"